import React from "react";

import { NavSpacerInterface } from "../types/NavSpacerInterface";

const NavSpacer = ({
  animate,
  direction,
  step,
  totalItems,
}: NavSpacerInterface) => {
  let spacerClass = `spacer`;
  if (animate) spacerClass += ` animate ${direction} step-${step}`;

  return (
    <div className={spacerClass}>
      <div className="bar" />
    </div>
  );
};

export default NavSpacer;
